<app-info-page
  title="{{ 'project.projectsOverviewTitle' | translate }}"
  [isComponentOrProject]="'PROJECT'"
>
  <app-button
    theme="primary"
    [id]="'btn-create-project'"
    class="btn-create-project"
    [routerLink]="['/projects/create']"
    [queryParams]="{ solution: solutionSpace, origin: getOrigin() }"
    ngProjectAs="buttons"
    buttonText="{{ 'project.createProject' | translate }}"
    iconUrl="/assets/icons/icon-16-add.svg"
  ></app-button>

  @if (dualSolutions()) {
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="solution-tabs grey-bg">
    @for (link of links; track link.id) {
    <a mat-tab-link [routerLink]="link.path" (click)="activeLink = link.id" [active]="activeLink === link.id">
      {{ link.label | translate }}
    </a>
    }
  </nav>
  }
  <mat-tab-nav-panel #tabPanel class="solution-panel" [attr.role]="dualSolutions() ? 'tabpanel' : null">
    <div class="filter-container space-between grey-bg project-filter-padding">
      <app-search-field
        class="search-field"
        (keyUp)="onSearchFieldUpdate($event)"
        [placeHolder]="'component.OVERVIEW.FORM-FIELD.PLACE_HOLDER' | translate"
      ></app-search-field>
      <button class="hover-button margin-right-xs" mat-button [matMenuTriggerFor]="filter">
        <svg-icon [svgStyle]="{ 'width.px': 16 }" class="icon-hover" src="/assets/icons/filter.svg"> </svg-icon>
        {{ displayedText }}
      </button>
    </div>
    <mat-menu #filter="matMenu">
      <button mat-menu-item (click)="setArchiveControl(false)">Active</button>
      <button mat-menu-item (click)="setArchiveControl(true)">Archived</button>
    </mat-menu>

    @if (loaded) {
    <div class="project-wrapper">
      @for (project of projects; track project) {
      <div class="project-item">
        <app-zx-project-list-card [zxProject]="project" [solution]="solutionSpace"></app-zx-project-list-card>
      </div>
      }
    </div>
    } @else {
    <div class="spinner-wrapper">
      <mat-spinner></mat-spinner>
    </div>
    }
    @if (bp.isPhone() && loaded && projects.length < totalItems) { @if (loadError) {
    <div class="load-more">
      <button mat-button type="button" (click)="loadNextPage()">Could not load more. Try again</button>
    </div>
    } @else {
    <div class="load-more" aria-hidden="true" [appLoadMore]="projects.length" (loadMore)="loadNextPage()">
      <span class="load-more-ring"></span>
    </div>
    } } @if (!bp.isPhone()) {
    <mat-paginator
      class="project-mat-paginator"
      [pageIndex]="pageNumber - 1"
      [length]="totalItems"
      [pageSize]="pageSize"
      (page)="handlePageEvent($event)"
      hidePageSize
      showFirstLastButtons
    >
    </mat-paginator>
    }
  </mat-tab-nav-panel>
</app-info-page>
